import { atom, useAtom } from "jotai";

export type Tab = "upload" | "products" | "size" | "front" | "back";

const visitedTabsAtom = atom<Set<Tab>>(new Set<Tab>());

export const useVisitedTabs = () => useAtom(visitedTabsAtom);
